import styled from "styled-components"
import H1, { H1Desktop } from "./H1"
import { ColorVariant, getVariantColor } from "../../../utils/theme-helpers"

const ColorfulH1 = styled(H1Desktop)<{ color: ColorVariant }>`
  background: ${({ color }) => getVariantColor(color)};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`

export default ColorfulH1
